import { filemanagerApi } from "@/config/http-filemanager";
import { IBackendResponse } from "@/store";

class FileDataService {
  getAll(params: any): Promise<any> {
    return filemanagerApi.post("/upload", params, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  }

  download(fileGuid: string): Promise<{
    data: {
      fileInfo: { type: string; name: string; guid: string; ext: string };
      fileData: ArrayBuffer;
    };
  }> {
    return filemanagerApi.get("/download-with-info", {
      params: {
        file: fileGuid,
      },
      responseType: "json",
    });
  }

  upload(file: File) {
    const formData = new FormData();
    formData.append("file", file, file.name);
    return filemanagerApi.post("/upload", formData);
  }

  getFilesInfo(guids: string[]): Promise<{ data: unknown[] }> {
    return filemanagerApi.post("/files-info", guids);
  }

  downloadBlob(fileGuid: string): Promise<{ data: Blob }> {
    return filemanagerApi.get("/download", {
      params: { file: fileGuid },
      responseType: "blob",
    });
  }
}

export default new FileDataService();
